import React, { useEffect, useState } from 'react';
import { RouteChildrenProps } from 'react-router-dom';
import { Box, constants } from '@match/react-component-library';
import { Topic } from 'types';
import { TopicView } from 'modules/components';
import apiServices from 'utils/api-services';

const { SPACE } = constants;

interface RouteParams {
  deeplink: string;
}

const DeeplinkTopicPage: React.FunctionComponent<RouteChildrenProps<RouteParams>> = (props) => {
  const [currentTopic, setCurrentTopic] = useState<Topic>();
  const [catName, setCatName] = useState('');
  const { match } = props;
  const deeplink = match?.params.deeplink;

  useEffect(() => {
    if (deeplink) {
      apiServices
        .getTopicByAlias(deeplink)
        .then((item) => {
          setCurrentTopic(item.topic);
          setCatName(item.categoryName);
        })
        .catch((err) => console.log(err)); // TODO this should probably be a 404 page
    }
  }, []);

  if (!currentTopic) return null;
  const { answer, categoryId, id, title } = currentTopic;
  return (
    <Box center maxWidth="95%" paddingX={SPACE.XLARGE}>
      <TopicView
        answer={answer}
        categoryId={categoryId}
        categoryName={catName}
        id={id}
        showHelpBreadcrumb
        title={title}
      />
    </Box>
  );
};

export default DeeplinkTopicPage;
